<template>
  <svg
    class="heart-cropper"
    viewBox="0 0 100 100"
  >
    <defs>
      <clipPath
        id="cropper"
        clipPathUnits="objectBoundingBox"
      >
        <path
          d="M.50,.99 L.08,.55
        A.15,.15 0 0,1 .50,.15
        A.15,.15 0 0,1 .92,.55
        z"
        ></path>
      </clipPath>
    </defs>
  </svg>
</template>
